<template>
  <div class="pointMutation publicLess">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoad"
      class="van-load"
    >
      <div class="null-box" v-if="isEmpty">
        <van-empty
          class="custom-image"
          image-size="100px"
          :image="require('../../../../assets/not.png')"
          description="未检出"
        />
      </div>

      <div class="aaa" v-else>
        <div
          class="mutation-list publicLess-list"
          v-for="(item, index) in list"
          :key="index"
        >
          <h1 @click="geneClick(item)">{{ item.geneName }}</h1>
          <div class="show-box"></div>
          <div class="data-box">
            <div class="left">
              <div>
                <p>核苷酸</p>
                <h2>{{ item.cdnaChange }}</h2>
              </div>
              <div>
                <p>突变类型</p>
                <h2>{{ item.variantClassification }}</h2>
              </div>
              <div>
                <p>染色体</p>
                <h2>{{ item.chromosome }}</h2>
              </div>
              <div>
                <p>转录本</p>
                <h2>{{ item.refseqMrnaId }}</h2>
              </div>
              <!-- <div>
                <p>相同变异患者</p>
                <h3 @click="byClick(item)">{{ item.cohort }}</h3>
              </div> -->
            </div>
            <div class="right">
              <div>
                <p>氨基酸</p>
                <h3 @click="wdClick(item)">{{ item.proteinChange }}</h3>
              </div>
              <div>
                <p>频率</p>
                <h2>{{ item.tumorMutantFrequency }}</h2>
              </div>
              <div>
                <p>外显子</p>
                <h2>{{ item.exonNum }}</h2>
              </div>
              <div v-if="$route.query.userAgent != 'wxWeb'">
                <p>相同变异患者</p>
                <h3 @click="byClick(item)">{{ item.cohort }}</h3>
              </div>
              <!-- <div>
                <p>变异等级</p>
                <h2>{{ "" }}</h2>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { snvData } from "@/api/reportQuery";
import { handleSearch } from "@/utils/search";
import { Toast } from "vant";
import { mapState } from "vuex";
import isiOS from "@/utils/iosAn";

export default {
  name: "pointMutation",
  props: {
    searchVal: {
      type: String,
    },
  },
  data() {
    return {
      isEmpty: false,
      loading: false,
      finished: false,
      mutationData: [],
      list: [],
      badge: "",
      searchData: [],
    };
  },
  mounted() {
    this.getSnv();
  },
  watch: {
    searchVal: function (val) {
      if (!val) {
        this.clearSearch();
      }
    },
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  methods: {
    // 氨基酸位点点击事件
    wdClick(item) {
      console.log(item);
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.variation,
        // proteinChange: "-" + item.proteinChange,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "snv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url:
            "/packageWebView/pages/site-jiedu/site-jiedu?site=" + item.proteinChange,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 基因点击事件
    geneClick(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        gene: item.geneName,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "snv",
        webId: "BGXQ-TXBBYJG",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/gene-jiedu/gene-jiedu?gene=" + item.geneName,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    byClick(item) {
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.geneName,
        proteinChange: "-" + item.proteinChange,
        tabIndex: "1",
        Jump: "1",
        fromSource: "snv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    clearSearch() {
      this.list = this.searchData;
      this.finished = false;
      this.isEmpty = false;
    },
    searchFn() {
      /**搜索查询的方法 */
      if (this.searchVal) {
        this.finished = true;

        this.list = handleSearch(this.searchVal, this.mutationData);
        if (this.searchVal != "" && this.list.length === 0) {
          this.isEmpty = true;
        }
      }
    },
    getSnv() {
      this.loading = true;
      this.$nextTick(async () => {
        try {
          let { data } = await snvData({
            labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
            productId: this.publicParams.productId,
          });
          this.mutationData = data;
          this.list = this.mutationData;
          this.searchData = this.mutationData;
          if (data == "") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          // this.badge = data.length;
          // if (this.badge > 100) {
          //   this.badge = 99 + "+";
          // }
          // this.$emit("badge-snv", this.badge);

          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      });
    },
    uniqueArray(paylist) {
      var payArr = [paylist[0]];
      for (var i = 1; i < paylist.length; i++) {
        var payItem = paylist[i];
        var repat = false;
        for (var j = 0; j < payArr.length; j++) {
          if (payItem.uid == payArr[j].uid) {
            repat = true;
            break;
          }
        }
        if (!repat) {
          payArr.push(payItem);
        }
      }
      return payArr;
    },
    onLoad() {
      this.loading = false;

      // 异步更新数据

      // if (this.mutationData.length == 0) {
      //   this.finished = true;
      // } else {
      //   this.list = this.mutationData;
      //   this.searchData = this.mutationData;
      //   // if (this.mutationData.length < 10) {
      //   //   this.list = this.mutationData;
      //   //   this.searchData = this.mutationData;
      //   // } else {
      //   //   for (let i = 0; i < 5; i++) {
      //   //     this.list.push(this.mutationData[i]);
      //   //     this.searchData.push(this.mutationData[i]);
      //   //   }
      //   // }

      //   // 加载状态结束
      //   // 数据全部加载完成
      //   if (this.list.length >= this.mutationData.length) {
      //     this.finished = true;
      //   }
      // }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./styles/index.less";
</style>
